import {z} from 'zod';
import {stringToJSONSchema} from '@netx/core-next/schema/utils';

/*
// server response
{
    "id": 3,
    "event": "adBuilder:templates:route",
    "portalId": 1,
    "goo": "{\\\"label\\\":\\\"Templates\\\",\\\"userLevel\\\":0,\\\"link\\\":\\\"\\\",\\\"assetName\\\":\\\"\\\",\\\"type\\\":\\\"action\\\"}",
    "userId": 0,
    "modDate": "2019-09-20 16:46:39"
}[]
*/

export enum BrandPortalActionType {
	ACTION = 'action',
	ASSET = 'asset',
	CATEGORY = 'category',
	PAGE = 'page',
	URL = 'url',
}

export const BRAND_PORTAL_ACTION_GOO_KEYS = [
	'label',
	'userLevel',
	'link',
	'assetName',
	'type',
] as const;

export const BrandPortalActionSchema = z.object({
	id: z.number().int().positive(),
	event: z.string(),
	/** ex 2019-09-20 16:46:40 */
	modDate: z.string(),
	portalId: z.number().int().positive(),
	userId: z.number().int().positive(),
	goo: stringToJSONSchema.pipe(
		z.object({
			label: z.string(),
			userLevel: z.number().int().positive(),
			link: z.string(),
			assetName: z.string(),
			type: z.nativeEnum(BrandPortalActionType),
		}),
	),
});

export const BrandPortalActionRawSchema = BrandPortalActionSchema.omit({
	goo: true,
}).extend({
	goo: z.string(),
});

export type IBrandPortalAction = z.infer<typeof BrandPortalActionSchema>;

export type IBrandPortalActionRaw = z.infer<typeof BrandPortalActionRawSchema>;
